import React from "react";
import { useAuth } from "../../Context/authContext";
import StudentEngagements from "./StudentEngagements";
import MentorEngagements from "./MentorEngagements";

const Component = () => {
  const { user } = useAuth();

  // Route to appropriate component based on user role
  if (user?.role === 'mentor') {
    return <MentorEngagements />;
  }

  // Default to student flow
  return <StudentEngagements />;
};

export default Component;

